import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs'

import { RaService, EmailMessages, EmailAuditPackages, UpdateStateService } from '../../../../core';
import {  NgForm }   from '@angular/forms';

export interface SelectDlgRecipientVM {
  selected: boolean,
  display: string,
  emailMessages: EmailMessages,
  package: EmailAuditPackages
}

export enum SelectDlgMode { propertyMode = 0, finalConfirmMode = 1 };
export interface ProgressInfo {
  current: number,
  total: number,
  message: string
}

@Component({
  selector: 'app-select-dlg',
  templateUrl: './select-dlg.component.html',
  styleUrls: ['./select-dlg.component.scss']
})



export class SelectDlgComponent implements OnInit,OnDestroy {
  emailMessage:string="The following email packages have been selected to be sent out:";
  constructor(
    private updateStateService: UpdateStateService<ProgressInfo>
  ) {
    this.initProgressInfo();
  }
  ngOnInit() {
    this.updateCounts();
    let s1 = this.updateStateService.watchState.subscribe((nxt) => this.onUpdateProgress(nxt, this)
      , (err) => { console.log(err); });
    this.subscriptions.push(s1);
  }
  ngOnDestroy(){
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  subscriptions:Subscription[]=[];

  @ViewChild('userForm', { static: true }) userForm:NgForm;
  @Input() displayItems: SelectDlgRecipientVM[] = [];
  @Input() selectDlgMode: SelectDlgMode = SelectDlgMode.propertyMode;
  @Input() auditType: string;
  @Output() done: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendPackages: EventEmitter<any> = new EventEmitter<any>();

  totalPackages = 0;
  passPackages = 0;
  failPackages = 0;
  progressInfo: ProgressInfo;
  onSelectAll() {
    this.displayItems.forEach(r => r.selected = true);
    this.updateCounts();
  }
  updateCounts(){
    this.passPackages = 0;
    this.failPackages = 0;
      if( this.displayItems.length!=0){
      this.displayItems.forEach(r => {
        if(r.selected == true){
          if(r.package.Status == "F"){
            this.failPackages++;
          }else if(r.package.Status == "P"){
            this.passPackages++;
          }
        }
      });
    }
    else{
      this.emailMessage="No email address left to send"
    }
    this.totalPackages = this.passPackages + this.failPackages;

  }
  onSelectNone() {
    this.displayItems.forEach(r => r.selected = false);
    this.updateCounts();

  }
  onCancel() {
    if (!this.disableButtons) {
      this.cancel.emit();

    }
  }
  isEmpty(list: SelectDlgRecipientVM[]) {
    return !list.some(r => r.selected);
  }
  showProgress: boolean = false;
  initProgressInfo() {
    this.progressInfo = { current: 0, total: 0, message: '' }
  }
  onApplyChangesOrSendPackages() {
    if (this.selectDlgMode == SelectDlgMode.propertyMode) {
      this.done.emit();
    } else {
      if (!this.disableButtons) {
        this.initProgressInfo();
        this.disableButtons = true;
        this.showProgress = true;
        this.sendPackages.emit(true);
      }
    }
  }
  disableButtons: boolean = false;
  percentComplete: number;
  onUpdateProgress(nxt: ProgressInfo, dis: SelectDlgComponent) {
    let current = nxt.current>0?(nxt.current-1):(0);
    let pcnt = ~~((current / nxt.total) * 100);
    this.percentComplete = pcnt;
    dis.progressInfo = nxt;
    if (nxt.current >= (nxt.total+1)) {
      dis.showProgress = false;
      dis.initProgressInfo();
      dis.done.emit();
    }
  }
}
